/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Button from '../button/button';
import './styles/_index.scss';

const PropertyCallout = () => {
    return (
        <div className="property-callout">
            <div className="shell">
                <div className="property-callout__inner">
                    <div className="property-callout__text">
                        <h3>Do you have a property to sell?</h3>
                        <p>Get a free home valuation from one of our team</p>
                    </div>
                    
                    <Button className="btn--fill-lightblue" link="/property-valuation/">Book a Valuation</Button>
                </div>
            </div>
        </div>
    )
}

export default PropertyCallout;
